const en = {
    TIMER: "minutes left",
    SCAN_TO_PAY: "Scan to Pay",
    SEND_PAYMENT: "Scan QR code and send payment to <b className='text-gray-900'>One Site Service</b>",
    INVOICE_NUMBER: "Invoice number",
    BTN_DOWNLOAD_QR: "Download QR Code",
    BTN_COMPLETE_PAYMENT: "Complete Payment",
    HOW_TO_PAY_WITH_SCAN: "How to pay with QR Scan",
    STEP1: "Open KBZPay App",
    STEP2: "Scan this QR Code",
    STEP3: "Complete Payment",
}

const mm = {
    TIMER: "မိနစ်ကျန်ရှိ ပါသည်။",
    SCAN_TO_PAY: "ငွေပေးချေရန် စကင်န်ဖတ်ပါ။",
    SEND_PAYMENT: "QRကုဒ်ကို စကင်န်ဖတ်ပြီး <b className='text-gray-900'>One Site Service</b> သို့ ငွေပေးချေမှုပြုလုပ်ပါ။",
    INVOICE_NUMBER: "ဘောင်ချာနံပါတ်",
    BTN_DOWNLOAD_QR: "QRကုဒ်ကို ဒေါင်းလုဒ်လုပ်ပါ။",
    BTN_COMPLETE_PAYMENT: "ငွေပေးချေမှုပြီးပါပြီ။",
    HOW_TO_PAY_WITH_SCAN: "စကင်န်ဖြင့် ငွေပေးချေနည်း",
    STEP1: "KBZPay App ကိုဖွင့်ပါ။",
    STEP2: "QRကုဒ်ကို စကင်န်ဖတ်ပါ။",
    STEP3: "ငွေပေးချေမှုပြီးပါပြီ။",
}

const ch = {
    TIMER: "剩余分钟",
    SCAN_TO_PAY: "扫描支付",
    SEND_PAYMENT: "扫描二维码并向 <b className='text-gray-900'>One Site Service</b> 付款",
    INVOICE_NUMBER: "发票号码",
    BTN_DOWNLOAD_QR: "下载二维码",
    BTN_COMPLETE_PAYMENT: "完成付款",
    HOW_TO_PAY_WITH_SCAN: "如何使用二维码扫描付款",
    STEP1: "打开 KBZPay 应用",
    STEP2: "扫描此二维码",
    STEP3: "完成付款",
}

const MSG = {
    en, mm, ch
}

export default MSG;
